export const countryToCurrency = (country) => {
    switch ((country || '').toUpperCase()) {
        case 'UK':
            return '£';
        case 'CH':
            return 'CHF';
        case 'CZ':
            return 'CZK';
        case 'RO':
            return 'RON';
        case 'SE':
            return 'SEK';
        case 'DK':
            return 'DKK';
        case 'PL':
            return 'PLN';
        case 'HU':
            return 'HUF';
        case 'NO':
            return 'NOK';
        default:
            return '€';
    }
};
